import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import SD_DATA from 'sd-data'
import SD_AD from 'sd-ad'
import Utils from './utils'
import account from 'sd-account'

Vue.use(account, { userThirdScope: 'base', thirdType: 17 })

Vue.prototype.$Utils = Utils
Vue.SD_DATA = Vue.$SD_DATA = Vue.prototype.$SD_DATA = SD_DATA

const sdDataOption = {
  biz: 'cf'
}
Vue.use(SD_DATA.vueRouterPlugin, {
  pageExt: [
    {
      ext: 'project_id_luban',
      type: 'function',
      key: function() { return 'p448jrzbdnxy'}
    }
  ]
})
Vue.SD_DATA.init(sdDataOption)
Vue.SD_DATA.autoTrack()

Vue.use(SD_AD, {})

Vue.config.productionTip = false
Vue.use(window['common-text'].default)

Vue.sdAccount.login({ url: window.location.href }).then(async () => {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}).catch(e => {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})

